<div class="home-container">
  <cognos-header></cognos-header>
  <cognos-company-list></cognos-company-list>
</div>
